const actions = {
  SET_STATE: 'calls/SET_STATE',
  GET_CALL_LOGS: 'calls/GET_CALL_LOGS',
  DOWNLOAD_CALL_RECORDING: 'calls/DOWNLOAD_CALL_RECORDING',
  DOWNLOAD_CALL_RECORDING_LEGACY: 'calls/DOWNLOAD_CALL_RECORDING_LEGACY',
  GET_CALL_BY_ID: 'calls/GET_CALL_BY_ID',
  GET_CALL_SESSION_PARTICIPANT_DETAILS: 'calls/GET_CALL_SESSION_PARTICIPANT_DETAILS',
  GET_CALL_LOGS_LEGACY: 'calls/GET_CALL_LOGS_LEGACY',
  GET_CALL_BY_ID_LEGACY: 'calls/GET_CALL_BY_ID_LEGACY',
}

export default actions
